import { render, staticRenderFns } from "./InfoDiscountAdditionModal.vue?vue&type=template&id=dcb870f2&scoped=true"
import script from "./InfoDiscountAdditionModal.vue?vue&type=script&lang=js"
export * from "./InfoDiscountAdditionModal.vue?vue&type=script&lang=js"
import style0 from "./InfoDiscountAdditionModal.vue?vue&type=style&index=0&id=dcb870f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcb870f2",
  null
  
)

export default component.exports